import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

function DataTable({ data, config, renderCell, ...props }) {
  const dataToRender = (data || []).map((row, _id) => ({ ...row, _id }));
  return (
    <BootstrapTable
      striped
      bordered={false}
      data={dataToRender}
      {...config}
      {...props}
    >
      {[
        <TableHeaderColumn key="_id" dataField="_id" isKey hidden>
          ID
        </TableHeaderColumn>,
      ].concat(
        ...config.columns.map((column) => (
          <TableHeaderColumn
            {...column}
            key={column.label}
            csvHeader={column.label}
            formatExtraData={column}
            dataFormat={(...args) => {
              if (column.dataFormat) {
                args[0] = column.dataFormat(...args);
              }
              if (renderCell) {
                args[0] = renderCell(...args);
              }
              return args[0];
            }}
          >
            {column.label}
          </TableHeaderColumn>
        )),
      )}
    </BootstrapTable>
  );
}

DataTable.propTypes = {
  data: PropTypes.array,
  config: PropTypes.object,
  renderCell: PropTypes.func,
};

export default DataTable;
